module.exports = __webpack_public_path__ + "img/public/SiteIcons/Group 39536.svg?e29c0ba9";